import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbInputModule,
  NbToastrService,
} from "@nebular/theme";
import { FileUpload } from "primeng/fileupload";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../store/reducers";
import { AssetDocumentNewChanges } from "../ngrx/asset-document-upload.actions";
import {
  DocumentApiRoutesEnum,
  DocumentService,
} from "../../../../services/document.service";

@Component({
  selector: "ngx-asset-document-upload",
  templateUrl: "./asset-document-upload.component.html",
  styleUrls: ["./asset-document-upload.component.scss"],
  imports: [
    NbCardModule,
    FileUpload,
    FormsModule,
    ReactiveFormsModule,
    NbInputModule,
    NbButtonModule,
  ],
})
export class AssetDocumentUploadComponent implements OnInit {
  @Input() assetId: number | null;
  @ViewChild("fileUpload") assetDocumentFileUpload: FileUpload;
  documentCreateUrl: string;
  assetDocumentUploadForm = new FormGroup({
    caption: new FormControl("", Validators.required),
  });
  constructor(
    protected ref: NbDialogRef<any>,
    private toast: NbToastrService,
    private store: Store<AppState>,
    private documentService: DocumentService,
  ) {}

  ngOnInit(): void {
    this.documentCreateUrl = this.documentService.getEndpointUrl(
      DocumentApiRoutesEnum.DocumentCreate,
    );
  }
  onSubmit() {
    if (
      this.assetDocumentUploadForm.valid &&
      this.assetDocumentFileUpload.files &&
      this.assetDocumentFileUpload.files.length === 1
    ) {
      this.assetDocumentFileUpload.upload();
    } else {
      this.toast.warning(
        "Please fill out the form correctly and select a file to upload.",
      );
    }
  }
  onBeforeUpload($event: { formData: FormData }) {
    $event.formData.append(
      "model.Caption",
      this.assetDocumentUploadForm.get("caption").value,
    );
    $event.formData.append("model.AssetId", this.assetId.toString());
  }
  onSend() {
    this.toast.info("Uploading Asset Document...");
  }

  onUpload() {
    this.toast.success("Asset Document Uploaded Successfully.");
    this.store.dispatch(AssetDocumentNewChanges());
    this.close();
  }

  onError() {
    this.toast.danger("Asset Document Upload Failed.");
  }

  close(): void {
    this.ref.close();
  }
}
